import React, { useEffect, useState } from 'react';
import { Col, Container, NavbarBrand, Row } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav'
import { getUserInfo } from '../../services/UserService';
import Navbar from 'react-bootstrap/Navbar'
import { VerifyEmail } from '../VerifyEmail';
import { useAuth } from '../../contexts/AuthContext';
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown'
import leadtubLogoWhite from '../../assets/logo/leadtubLogoWhite.png'
import '../../style/LeftsideNavbar.css'
import { svgs } from "../CONSTANTS";
import { Leadtubadminnavbar } from "./Leadtubadminnavbar";


const LeftsideNavbar = () => {


    const { currentUser, logout, handleEmailVerification, trulyAuthenticated } = useAuth();
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState({});


    useEffect(() => {
        const getUser = async () => {
            if (currentUser) {
                setUser(await getUserInfo(currentUser.uid))

            }
        }
        getUser()


        return (() => {
            getUser()
        })
    }, [currentUser])


    const handleClick = async () => {
        await logout()
    }

    const handleVerify = async () => {

        const res = await handleEmailVerification()

    }


    return (
        <React.Fragment>

            {!loading && currentUser && trulyAuthenticated ? (

                <React.Fragment>
                    <Navbar defaultValue="/dashboard" bg="dark"
                        style={{
                            width: "12%",
                            float: "left",
                            height: "100vh",
                            top: "0",
                            position: 'sticky-top',
                            justifyContent: "center"
                        }} className="sticky-top">
                        <Container fluid color={"black"} className="align-self-start"
                            style={{ justifyContent: "center" }}>

                            <Row>
                                <Col>
                                    <NavbarBrand href="/dashboard">
                                        <img src={leadtubLogoWhite} alt="logo" className="display-1" style={{
                                            display: 'block',
                                            marginLeft: "auto",
                                            marginRight: "auto",
                                            justifySelf: "center",
                                            width: "8vw"
                                        }} />
                                    </NavbarBrand>
                                </Col>
                                <Col>
                                    <Nav.Link href="/dashboard">
                                        <span className={"navbarspan"}>
                                            <span className="svgPad">
                                                {svgs[0]}
                                            </span>
                                            <span>
                                                Översikt
                                            </span>

                                        </span>
                                    </Nav.Link>
                                </Col>
                                <Col>
                                    <Nav.Link href="/leads"
                                        className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                                        <span className={"navbarspan"}>
                                            <span className="svgPad">
                                                {svgs[1]}
                                            </span>
                                            <span>
                                                Leads
                                            </span>
                                        </span>
                                    </Nav.Link>
                                </Col>
                                <Col>
                                    <Nav.Link href="/users"> <span className={"navbarspan"}>
                                        <span className="svgPad">
                                            {svgs[2]}
                                        </span>
                                        <span>
                                            Användare
                                        </span>
                                    </span>
                                    </Nav.Link>
                                </Col>
                                <Col>
                                    <Nav.Link href="/settings"> <span
                                        className={"navbarspan"}>
                                        <span className="svgPad">
                                            {svgs[3]}
                                        </span>
                                        <span>
                                            Inställningar
                                        </span>
                                    </span>
                                    </Nav.Link>
                                </Col>


                                <Col>
                                    <Nav.Link href="/contact-us"> <span
                                        className={"navbarspan"}>
                                        <span className="svgPad">
                                            {svgs[4]}
                                        </span>
                                        <span>
                                            Kontakt
                                        </span>
                                    </span>
                                    </Nav.Link>
                                </Col>




                            </Row>

                        </Container>
                    </Navbar>
                    <Navbar variant="dark" style={{}}>
                        <Nav className="ms-lg-auto">
                            <Dropdown drop={"left"}>
                                <Dropdown.Toggle
                                    style={{ backgroundColor: "rgba(255,255,255,0)", border: "none", marginRight: 30 }}
                                    variant="custom">


                                    <svg width="80" height="80" overflow="visible" viewBox="25 9 50 82">
                                        <circle cx="50" cy="50" r="21" fill="#C4C4C4" />
                                        <svg x="38" y="35.5" width="24" height="29" viewBox="0 0 12 16" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M6 8.88794C3.23858 8.88794 1 11.0612 1 13.7421V13.9556C1 14.5079 1.44772 14.9556 2 14.9556H10C10.5523 14.9556 11 14.5079 11 13.9556V13.7421C11 11.0612 8.76142 8.88794 6 8.88794Z"
                                                fill="#545454" stroke="#545454" />
                                            <ellipse cx="6.00058" cy="4.64059" rx="3.75003" ry="3.64059" fill="#545454"
                                                stroke="#545454" />
                                        </svg>
                                    </svg>


                                </Dropdown.Toggle>




                                <Dropdown.Menu
                                    position={"sticky"}
                                    drop={"left"}
                                >

                                    <span>
                                        <Link to={`/companydetails/${user.company}`}>
                                            {user?.company}
                                        </Link>
                                    </span>

                                    <Dropdown.Item>
                                        {user?.firstName} {user?.lastName}
                                        <br />
                                        {user?.email}
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Link to={`/accountdetails/${currentUser.uid}`}>

                                        Kontouppgifter
                                    </Link>


                                    <Dropdown.Item>
                                        <VerifyEmail emailVerified={currentUser.emailVerified} />

                                    </Dropdown.Item>

                                    <Dropdown.Item onClick={handleClick} style={{ color: 'red' }}>Logga
                                        ut </Dropdown.Item>

                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>
                        {user.superadmin ?
                            <Leadtubadminnavbar />
                            : undefined
                        }
                    </Navbar>

                </React.Fragment>

            ) : null}

        </React.Fragment>
    )
}
export default LeftsideNavbar;
